import bigInt from "big-integer";
import Web3 from "web3";
import ETHLogo from "../assets/ETH-icon.png";

import USDCLogo from "../assets/USDC-icon.png";

import BUIDLBanner from "../assets/banners/buidl.jpeg";
import BUIDLBannerMobile from "../assets/banners/buidl-mobile.jpeg";

export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT; // set to testnet if we are testing

export const CONNECTION_CONNECTED = "CONNECTION_CONNECTED";
export const CONNECTION_DISCONNECTED = "CONNECTION_DISCONNECTED";

export const ERROR = "ERROR";

export const CONFIGURE = "CONFIGURE";
export const CONFIGURE_RETURNED = "CONFIGURE_RETURNED";

export const STAKE = "STAKE";
export const STAKE_V1 = "STAKE_V1";
export const STAKE_RETURNED = "STAKE_RETURNED";

export const UNSTAKE = "UNSTAKE";
export const UNSTAKE_V1 = "UNSTAKE_V1";
export const UNSTAKE_RETURNED = "UNSTAKE_RETURNED";

export const CLAIM_HODLER = "CLAIM_HODLER";
export const CLAIM_HODLER_RETURNED = "CLAIM_HODLER_RETURNED";

export const GET_BALANCES = "GET_BALANCES";
export const GET_BALANCES_RETURNED = "GET_BALANCES_RETURNED";

export const GET_MIN_CREATOR_STAKED_BALANCE = "GET_MIN_CREATOR_STAKED_BALANCE";
export const GET_MIN_CREATOR_STAKED_BALANCE_RETURNED =
  "GET_MIN_CREATOR_STAKED_BALANCE_RETURNED";

export const GET_DEV_FEES = "GET_DEV_FEES";
export const GET_DEV_FEES_RETURNED = "GET_DEV_FEES_RETURNED";

export const GET_CLAIMABLE_ASSET = "GET_CLAIMABLE_ASSET";
export const GET_CLAIMABLE_ASSET_RETURNED = "GET_CLAIMABLE_ASSET_RETURNED";

export const CLAIM = "CLAIM";
export const CLAIM_RETURNED = "CLAIM_RETURNED";

export const PUBLIC_CLAIM = "PUBLIC_CLAIM";
export const PUBLIC_CLAIM_RETURNED = "PUBLIC_CLAIM_RETURNED";

export const UPDATE_REWARDS = "UPDATE_REWARDS";
export const UPDATE_REWARDS_RETURNED = "UPDATE_REWARDS_RETURNED";

export const GET_PUBLIC_PRESALE_INFO = "GET_PUBLIC_PRESALE_INFO";
export const GET_PUBLIC_PRESALE_INFO_RETURNED =
  "GET_PUBLIC_PRESALE_INFO_RETURNED";

export const GET_STAKING_POOLS_INFO = "GET_STAKING_POOLS_INFO";
export const GET_GENERALS_INFO = "GET_GENERALS_INFO";

export const GET_SWAP_INFO = "GET_SWAP_INFO";
export const GET_SWAP_INFO_RETURNED = "GET_SWAP_INFO_RETURNED";

export const INVEST = "INVEST";
export const INVEST_RETURNED = "INVEST_RETURNED";

export const PUBLIC_INVEST = "PUBLIC_INVEST";
export const PUBLIC_INVEST_RETURNED = "PUBLIC_INVEST_RETURNED";

export const LOCK_LIQUIDITY = "LOCK_LIQUIDITY";
export const LOCK_LIQUIDITY_RETURNED = "LOCK_LIQUIDITY_RETURNED";

export const GET_POOLS_SUMMARY = "GET_POOLS_SUMMARY";
export const GET_POOLS_SUMMARY_RETURNED = "GET_POOLS_SUMMARY";

export const APPLY = "APPLY";
export const APPLY_RETURNED = "APPLY_RETURNED";

export const VOTE = "VOTE";
export const VOTE_RETURNED = "VOTE_RETURNED";

export const GET_START_STATS = "GET_START_STATS";
export const GET_START_STATS_RETURNED = "GET_START_STATS_RETURNED";

export const COLLECT_FUND = "COLLECT_FUND";
export const COLLECT_FUND_RETURNED = "COLLECT_FUND_RETURNED";

export const CANCEL_PRESALE = "CANCEL_PRESALE";
export const CANCEL_PRESALE_RETURNED = "CANCEL_PRESALE_RETURNED";

export const SEND_UNSOLD_TOKENS = "SEND_UNSOLD_TOKENS";
export const SEND_UNSOLD_TOKENS_RETURNED = "SEND_UNSOLD_TOKENS_RETURNED";

export const MOVE_STAKE = "MOVE_STAKE";
export const MOVE_STAKE_RETURNED = "MOVE_STAKE_RETURNED";

export const WRITE = "WRITE";
export const WRITE_RETURNED = "WRITE_RETURNED";

export const CUSTOM_WRITE = "CUSTOM_WRITE";
export const CUSTOM_WRITE_RETURNED = "CUSTOM_WRITE_RETURNED";

export const ALLOW_CLAIM = "ALLOW_CLAIM";
export const ALLOW_CLAIM_RETURNED = "ALLOW_CLAIM_RETURNED";

export const GET_REFUND = "GET_REFUND";
export const GET_REFUND_RETURNED = "GET_REFUND_RETURNED";

export const THEME_CHANGE = "THEME_CHANGE";
export const THEME_CHANGE_RETURNED = "THEME_CHANGE_RETURNED";

export const THEME_MODE_CHANGE = "THEME_MODE_CHANGE";
export const THEME_MODE_CHANGE_RETURNED = "THEME_MODE_CHANGE_RETURNED";

export const SWAP = "SWAP";
export const SWAP_RETURNED = "SWAP_RETURNED";

export const FORMATE_ADDRESS = (address) => {
  if (!address) {
    return "";
  }
  return address.slice(0, 6) + "..." + address.slice(address.length - 4);
};

export const toFixed = (bi, decimals = 18, desired = 0) => {
  const trunc = decimals - desired;
  const shift = decimals - trunc;
  return (
    bigInt(bi)
      .divide(10 ** trunc)
      .toJSNumber() /
    10 ** shift
  ).toFixed(desired);
};

export const toWeiString = (ni, decimals = 18) => {
  const floatNumber = parseFloat(ni);
  let newFloatNumber = 0;

  if (decimals < 9) {
    newFloatNumber = parseInt(floatNumber * 10 ** decimals);
    return bigInt(newFloatNumber).toString();
  }

  newFloatNumber = parseInt(floatNumber * 10 ** 9);

  return bigInt(newFloatNumber)
    .multiply(bigInt(10).pow(decimals - 9))
    .toString();
};

export const isVotePassed = (presale) => {
  const yesVotes = parseFloat(toFixed(bigInt(presale?.yesVotes || "0"), 18, 4));
  const noVotes = parseFloat(toFixed(bigInt(presale?.noVotes || "0"), 18, 4));
  const minYesVotesThreshold = parseFloat(
    toFixed(bigInt(presale?.minYesVotesThreshold || "0"), 18, 4)
  );
  return yesVotes > noVotes + minYesVotesThreshold;
};

export function sleep(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

export const _getBanned = async () => {
  const bannedCountryCodes = {
    AE: true,
    AF: true,
    AL: true,
    BS: true,
    BB: true,
    BW: true,
    KH: true,
    CA: true,
    CU: true,
    GH: true,
    IR: true,
    IQ: true,
    JM: true,
    LY: true,
    MU: true,
    MM: true,
    NI: true,
    PA: true,
    PK: true,
    SS: true,
    SD: true,
    SY: true,
    TT: true,
    UG: true,
    US: true,
    VU: true,
    YE: true,
    ZW: true,
  };
  try {
    const url = "https://ipapi.co/json/";
    //"https://ipapi.co/json/?key=yUY1a5AheTMXT2cWartlptPMGcRpFNJaWOMROjrpg3CCspyabx/";
    const locationString = await fetch(url);
    const locationJSON = JSON.parse(locationString);
    if (locationJSON) {
      return bannedCountryCodes[locationJSON.country_code];
    }
    return false;
  } catch (e) {
    return false;
  }
};

export const fundingTokens = {
  base: [
    {
      value: "0x4200000000000000000000000000000000000006",
      label: "ETH",
      decimals: 18,
      logo: ETHLogo,
    },
    {
      value: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      label: "USDC",
      decimals: 6,
      logo: USDCLogo,
    },
  ],

  pulse: [
    {
      value: "0x4200000000000000000000000000000000000006",
      label: "ETH",
      decimals: 18,
      logo: ETHLogo,
    },
    {
      value: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
      label: "USDC",
      decimals: 6,
      logo: USDCLogo,
    },
  ],
};

export const tokens = {
  "0x4200000000000000000000000000000000000006": {
    label: "ETH",
    logo: ETHLogo,
    decimals: 18,
  },
  "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913": {
    label: "USDC",
    logo: USDCLogo,
    decimals: 6,
  },
};

export const defaultFundingAddress = {
  base:
    ENVIRONMENT === "mainnet"
      ? "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913"
      : "0x4200000000000000000000000000000000000006",
  pulse: "0x4200000000000000000000000000000000000006",
};

export const isSameAddress = (address1, address2) => {
  return (
    Web3.utils.isAddress(address1) &&
    Web3.utils.isAddress(address2) &&
    Web3.utils.toChecksumAddress(address1) ===
      Web3.utils.toChecksumAddress(address2)
  );
};

export const tiers = {
  base: [
    {
      label: "SILVER",
      value: 10000,
      tip: "SILVER: Voting power in IDOs plus first-come-first-serve (fcfs) access.",
    },
    {
      label: "GOLD",
      value: 50000,
      tip: "GOLD: SILVER benefits plus Guaranteed Allocation in IDOs.",
    },
    {
      label: "PLATINUM",
      value: 125000,
      tip: "PLATINUM: GOLD benefits plus access to our private Platinum club.",
    },
    {
      label: "DIAMOND",
      value: 250000,
      tip: "DIAMOND : GOLD benefits plus access to our private VIP club.",
    },
  ],
  pulse: [
    {
      label: "SILVER",
      value: 10000,
      tip: "SILVER: Voting power in IDOs plus first-come-first-serve (fcfs) access.",
    },
    {
      label: "GOLD",
      value: 50000,
      tip: "GOLD: SILVER benefits plus Guaranteed Allocation in IDOs.",
    },
    {
      label: "PLATINUM",
      value: 125000,
      tip: "PLATINUM: GOLD benefits plus access to our private Platinum club.",
    },
    {
      label: "DIAMOND",
      value: 250000,
      tip: "DIAMOND : GOLD benefits plus access to our private VIP club.",
    },
  ],
};

export const poolsSummaryUrl = {
  base:
    ENVIRONMENT === "mainnet"
      ? "https://base.api.starter.xyz/base/pools-list"
      : "https://test.base.api.starter.xyz/base/pools-list",
  pulse: "https://test.base.api.starter.xyz/base/pools-list",
};

export const buidlStatsUrl = {
  base:
    ENVIRONMENT === "mainnet"
      ? "https://base.api.starter.xyz/base/stats"
      : "https://test.base.api.starter.xyz/base/stats",
  pulse: "https://test.base.api.starter.xyz/base/stats",
};

export const defaultBuyUrls = {
  base: "https://app.uniswap.org/swap?inputCurrency=0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913&outputCurrency=0xdadc4f8e9d8d37294de0e02a2ce8cc0c90a4f6c2&chain=base",
  pulse:
    "https://pancakeswap.finance/#/swap?inputCurrency=0x31D0a7AdA4d4c131Eb612DB48861211F63e57610",
};

export const BANNER = {
  base: {
    themeType: "base",
    start: 1711591200,
    image: BUIDLBanner,
    mobileImage: BUIDLBannerMobile,
    link: "https://starter.xyz/",
  },
  pulse: {
    themeType: "pulse",
    start: 1711591200,
    image: BUIDLBanner,
    mobileImage: BUIDLBannerMobile,
    link: "https://starter.xyz/",
  },
};

export const GuideLinks = {
  base: "https://docs.starter.xyz/overview/about-the-team",
  pulse: "https://docs.starter.xyz/overview/about-the-team",
};
